// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"cta-link-block_uk-open__mRd03","grecaptcha-badge":"cta-link-block_grecaptcha-badge__lGTfd","root":"cta-link-block_root__zxzNe","title":"cta-link-block_title__ed2v2","subtitle":"cta-link-block_subtitle__V7TJI","icon":"cta-link-block_icon__zGnD2","text":"cta-link-block_text__Zf55N","arrow":"cta-link-block_arrow__aBH6S","withCount":"cta-link-block_withCount__5fQVf"};
    if(module.hot) {
      // 1751375820565
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  